import React from 'react'
import { Link } from 'react-router-dom'

export default function AdPromotionalBanner() {
  return (
    <>
      <Link to='/package-lead-form'>
        {/* <div className="promotional-banner-fastival">A Rakhi Gift from PartyWitty – Exclusive <span className="promotional-banner-fastival-span">Table Booking </span> Offers for You & Your Sibling!</div> */}

        <div className="promotional-banner-fastival">👉 Use code PARTY25 & get
          <span className="promotional-banner-fastival-span">₹750</span> OFF on your booking 🎁</div>
      </Link>
    </>
  )
}


